Librarian.Modules.Welcome = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        title: "Welcome",
        classPrefix: "modules-welcome-"
    }
});